var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalGuardarIcono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4028 1.45656C12.4881 1.04177 14.6495 1.25466 16.6139 2.0683C18.5782 2.88194 20.2571 4.2598 21.4383 6.02763C22.6195 7.79545 23.25 9.87386 23.25 12H22.5L23.25 12.0022C23.2418 14.8501 22.1068 17.5791 20.093 19.593C18.0791 21.6068 15.3501 22.7418 12.5022 22.75L12.5 22.75C10.3739 22.75 8.29545 22.1195 6.52763 20.9383C4.7598 19.7571 3.38194 18.0782 2.5683 16.1139C1.75466 14.1495 1.54177 11.9881 1.95656 9.90279C2.37135 7.81749 3.39519 5.90202 4.89861 4.39861C6.40202 2.89519 8.31749 1.87135 10.4028 1.45656ZM21.75 11.9991C21.7498 10.17 21.2073 8.3819 20.1911 6.86098C19.1747 5.33983 17.73 4.15423 16.0398 3.45412C14.3496 2.75401 12.4897 2.57083 10.6954 2.92774C8.9011 3.28465 7.2529 4.16563 5.95927 5.45927C4.66563 6.7529 3.78465 8.4011 3.42774 10.1954C3.07083 11.9897 3.25401 13.8496 3.95412 15.5398C4.65423 17.23 5.83983 18.6747 7.36098 19.6911C8.8819 20.7073 10.67 21.2498 12.4991 21.25C14.9503 21.2426 17.299 20.2656 19.0323 18.5323C20.7656 16.799 21.7426 14.4503 21.75 11.9991Z",
    fill: "#4EF3B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2808 8.64006C17.5734 8.93321 17.573 9.40809 17.2799 9.70072L11.6099 15.3607C11.3169 15.6532 10.8424 15.653 10.5497 15.3603L7.71967 12.5303C7.42678 12.2374 7.42678 11.7625 7.71967 11.4696C8.01256 11.1767 8.48744 11.1767 8.78033 11.4696L11.0805 13.7697L16.2201 8.63912C16.5133 8.34649 16.9882 8.34691 17.2808 8.64006Z",
    fill: "#4EF3B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalGuardarIcono);
export default __webpack_public_path__ + "static/media/modal-guardar-icono.8e285bd7881d12087636f669eea052f0.svg";
export { ForwardRef as ReactComponent };